import script from "./PopularCompetitions.vue?vue&type=script&setup=true&lang=js"
export * from "./PopularCompetitions.vue?vue&type=script&setup=true&lang=js"

import "./PopularCompetitions.vue?vue&type=style&index=0&id=46f0d88f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f0d88f"]])

export default __exports__